import { isHighContrastScheme } from '%evp_theme/brandbook/appearance/appearanceSchemes';

export const FOCUS_RING_WIDTH = 2;
export const HIGH_CONTRAST_FOCUS_RING_WIDTH = 3;

export function resolveFocusRingWidth(scheme) {
    return isHighContrastScheme(scheme) ? HIGH_CONTRAST_FOCUS_RING_WIDTH : FOCUS_RING_WIDTH;
}

export function createFocusRing(color, width) {
    return {
        outline: `${width}px solid ${color}`,
        outlineOffset: width - 1,
    };
}

export function createHighContrastFocusRing(colors) {
    return createFocusRing(colors.action, HIGH_CONTRAST_FOCUS_RING_WIDTH);
}

export function createInsetFocusRing(color, width) {
    return {
        outline: `${width}px solid ${color}`,
        outlineOffset: -width,
    };
}

function resolveThemeFocusRingWidth(theme) {
    return theme.shape.focusRingWidth ?? FOCUS_RING_WIDTH;
}

export function createThemeInsetFocusRing(theme) {
    return createInsetFocusRing(theme.palette.primary.main, resolveThemeFocusRingWidth(theme));
}

export default function createThemeFocusRing(theme) {
    return createFocusRing(theme.palette.primary.main, resolveThemeFocusRingWidth(theme));
}
